
































































/* eslint-disable */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Factories } from '@finx/web-repository'
import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'

@Component

export default class ViewDadosDeCobranca extends Vue {
  alert: any = {
    show: false
  }

  form: Object = {
    document: '',
    name: '',
  }

  formIsValid: Boolean = true
  loading: Boolean = false
  Messages = Factories.Messages
  Validator = Factories.Validator

  async submit() {
    setTimeout(() => {
      this.loading = false
      this.alert.show = true
    }, 1500)
  }

  validate() {
    const formIsValid = (this.$refs as any).form.validate()

    if (formIsValid) {
      this.loading = true
      this.submit()
    }
  }
}
